import { Link } from "react-router-dom";
import bumpitLogo from "@/assets/images/bumpit-black-optimized.png";
import bumpitLogoLight from "@/assets/images/bumpit-white-optimized.png";

interface LogoProps {
  variant?: "light" | "dark";
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ variant = "dark", className = "" }) => {
  const logoSrc = variant === "light" ? bumpitLogoLight : bumpitLogo;

  return (
    <Link to="/">
      <img
        src={logoSrc}
        alt="Bumpit Logo"
        className={`h-[27px] cursor-pointer ${className}`}
      />
    </Link>
  );
};

export default Logo;
